if (!customElements.get('fp-banner-finder')) {
  customElements.define('fp-banner-finder', class extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-banner-use]')];
      this.cards = [...this.querySelectorAll('[data-banner-card]')];
      this.result = this.querySelector('[data-banner-result]');
      this.buttons.forEach((button) => button.addEventListener('click', () => this.choose(button)));
    }
    choose(button) {
      const use = button.dataset.bannerUse;
      this.buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      this.cards.forEach((card) => {
        const match = (card.dataset.bannerType || '').split(' ').includes(use);
        card.classList.toggle('is-match', match);
        card.classList.toggle('is-dimmed', !match);
      });
      const messages = {
        hang: '<b>Best match:</b> 13 oz. vinyl banners for walls, storefronts, parties, and promotions.',
        wind: '<b>Best match:</b> Mesh banners let air pass through, making them better for windy outdoor locations.',
        stand: '<b>Best match:</b> Retractable and X-banner displays are portable, freestanding, and event-ready.'
      };
      this.result.innerHTML = button.dataset.resultMessage || messages[use] || '';
      this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
}
